import { AssignLicenseForm } from "./components";
import cn from "classnames";
import deviceSettings from "./DeviceSettings.module.scss";
import sharedStyles from "../shared.module.scss";
import { useFormatMessage } from "../i18n";

export function AssignLicensePage() {
  const tr = useFormatMessage();
  return (
    <div className={cn(sharedStyles.content, deviceSettings)}>
      <div className={cn(sharedStyles.headerContainer, sharedStyles.content)}>
        <h1 className={sharedStyles.pageTitle}>{tr("assign_license_title")}</h1>
      </div>
      <AssignLicenseForm isLicensePage />
    </div>
  );
}
